import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import moment from 'moment';
import Select from 'react-select';
import { itemsPerPage } from 'src/data/params';

import ringAnim from 'src/images/anim/ring.svg';
import CustomerSelect from './components/CustomerSelect';
import withAuth from 'src/hoc/withAuth';

const linkToDeal = '/dashboard/deal/';
const linkToCustomer = '/dashboard/customer/';
const linkToUser = '/dashboard/user/';
const apiEmployeeShow = '/api/employee/';
const apiDealType = '/api/dealType/';
const apiDealGet = '/api/deal/';
const apiDomainType = '/api/domains/';

const select_menu_data = {
  0: [{ value: 0, label: 'Tous' }],
  1: [
    { value: 0, label: 'Tous' },
    { value: 1, label: 'Proposition' },
    { value: 2, label: 'BDC' },
    { value: 3, label: 'Dossier-Prod' },
  ],
  2: [
    { value: 0, label: 'Tous' },
    { value: 1, label: 'Commande' },
    { value: 2, label: 'Préparation' },
    { value: 3, label: 'Installation' },
  ],
  3: [
    { value: 0, label: 'Tous' },
    { value: 1, label: 'A facturer' },
    { value: 2, label: 'Partiellement facturé' },
  ],
};

const oriState = {
  dataDeal: undefined,
  dataEmployee: undefined,
  dataDealType: undefined,
  dataDealCustomer: undefined,
  pendingFetch: false,
  dealDomain: '-1',
  domainTypes: undefined,
  offset: 0,
  filterDealState1: 0,
  filterDealState2: 0,
  filterDealDateASC: false,
  filterDealCustomer: undefined,
  filterDealType: -1,
  filterDealEmployeeCreator: -1,
};

class ExtendDeal extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.toggleDateFiltering = this.toggleDateFiltering.bind(this);
    this.init = this.init.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.seeMore = this.seeMore.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (name === 'filterDealState1') {
      // reset the 2nd select menu
      this.setState({
        filterDealState2: 0,
      });
    }
  }

  handleDomainChange = (event) => {
    const target = event.target;
    const value = target.value;

    this.setState({ dealDomain: value });
  };

  handleInputSelectChange(stateName, val) {
    const value = val ? val['id'] : -1;

    this.setState({
      [stateName]: value,
    });
  }

  clearFilter() {
    this.setState({
      filterDealDateASC: false,
      filterDealEmployeeCreator: -1,
      filterDealCustomer: undefined,
      filterDealType: -1,
    });
  }

  init() {
    this.getDomainTypes();
    this.loadEmployee();
    this.loadDealType();
  }

  seeMore() {
    this.refreshSearch(this.state.offset + 1);
  }

  getDomainTypes() {
    let queryURL = apiDomainType;
    let graphQL = '{ domains{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          domainTypes: data['data']['domains'],
        });
      })
      .catch(() => {
        console.log('erreur fetch domain types');
      });
  }

  refreshSearch(offsetNb) {
    let domainFilter = this.state.dealDomain !== '-1' ? `, domainId:${this.state.dealDomain || 1}` : '';

    this.setState({ pendingFetch: true }); // toggle loading anim
    let queryURL = apiDealGet;
    let graphQL =
      '{ deals(lost:false, standBy:false, orderBy:dateLastStep, ASC:' +
      this.state.filterDealDateASC +
      ', offset:' +
      itemsPerPage['deal_panorama'] * offsetNb +
      domainFilter +
      ', limit:' +
      itemsPerPage['deal_panorama'] +
      ', creatorId:' +
      this.state.filterDealEmployeeCreator +
      ', typeId:' +
      this.state.filterDealType +
      (this.state.filterDealCustomer
        ? `, customerIds:${JSON.stringify([this.state.filterDealCustomer])}, customerIdsOperator: "Fait partie de"`
        : '') +
      ' ,stepDeal:' +
      this.state.filterDealState1 +
      ', stepIntermediate:' +
      this.state.filterDealState2 +
      ')' +
      '{ hasMore, items{ id, name, stepNumber, type{ id, name}, creator{ user{ id, username } }, dateCreate, desiredClotureDate, dateLastStep, customer{ id, installationSite{ socialReason } }, type { name }, ' +
      'stepCommercial{ proposition{ pdc } }, ' +
      'stepProd{ id, intermediateStageNumber, dealOrder{ salesAssistant{ user{ id, username } } }, preparation{ orderPicker{ user{ id, username } }, installation{ installer{ user{ id, username } } } } }' +
      ' } } }';

    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['deals']['items']) {
            this.setState({
              offset: offsetNb, // increment or reset the current offset
              hasMore: data['data']['deals']['hasMore'],
              dataDeal:
                offsetNb > 0
                  ? this.state.dataDeal.concat(data['data']['deals']['items'])
                  : data['data']['deals']['items'],
              pendingFetch: false,
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch deal list \n' + error);
        }.bind(this)
      );
  }

  loadEmployee() {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['employees']) {
            this.setState({
              dataEmployee: data['data']['employees'],
            });
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch employee list: \n' + error);
        }.bind(this)
      );
  }

  loadDealType() {
    let queryURL = apiDealType;
    let graphQL = '{ dealTypes{ id, name } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['dealTypes']) {
          this.setState({
            dataDealType: data['data']['dealTypes'],
          });
        }
      })
      .catch((error) => {
        console.log('erreur fetch dealTypes list: \n' + error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.filterDealEmployeeCreator !== this.state.filterDealEmployeeCreator ||
      prevState.filterDealType !== this.state.filterDealType ||
      prevState.filterDealCustomer !== this.state.filterDealCustomer ||
      prevState.filterDealDateASC !== this.state.filterDealDateASC ||
      prevState.dealDomain !== this.state.dealDomain ||
      prevState.filterDealState1 !== this.state.filterDealState1 ||
      prevState.filterDealState2 !== this.state.filterDealState2
    ) {
      this.refreshSearch(0);
    } else if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
      // extend has been opened
      if (this.props.parentDealState && this.state.filterDealState1 !== this.props.parentDealState) {
        // sync w/ parent's call
        this.setState({
          filterDealState1: this.props.parentDealState,
        });
      } else {
        this.refreshSearch(0);
      }
      this.init();
    }
  }

  toggleDateFiltering(type) {
    this.setState({
      // reset filter
      [type]: !this.state[type],
    });
  }

  getRowColor(deal) {
    let res = 'transparent';
    let step = deal.stepProd.intermediateStageNumber;
    switch (step) {
      case 1:
        res = '#860000';
        break;
      case 2:
        res = '#FF7A3C';
        break;
      case 3:
        res = '#47D761';
        break;
    }
    return res;
  }

  render() {
    if (this.props.isOpen === false) return null;

    let { dataDeal } = this.state;
    let { dataEmployee } = this.state;
    let { dataDealType } = this.state;
    let noDeal = dataDeal && dataDeal.length === 0 ? <span>Aucun résultat.</span> : '';

    return (
      <div className='modal myModal myModal-xl extend'>
        <div className='modal-dialog modal-lg'>
          <div className='modal-content'>
            <div className='modal-header'>
              <div className='alignHorizontal'>
                <h4 className='modal-title'>Affaires</h4>
                <select
                  name='filterDealState1'
                  value={this.state.filterDealState1}
                  onChange={this.handleInputChange}
                  className='select-stock-search form-control'
                >
                  <option value={0}>Tous</option>
                  <option value={1}>Commercial</option>
                  <option value={2}>Production</option>
                  <option value={3}>Administratif</option>
                </select>

                {this.state.domainTypes && (
                  <select value={this.state.dealDomain} onChange={this.handleDomainChange} className='form-control'>
                    {this.state.domainTypes.map((type, key) => (
                      <option value={type.id} key={key}>
                        {type.name}
                      </option>
                    ))}
                    <option value={-1} key='All'>
                      Tout afficher
                    </option>
                  </select>
                )}

                {this.state.filterDealState1 != 0 && (
                  <select
                    name='filterDealState2'
                    value={this.state.filterDealState2}
                    onChange={this.handleInputChange}
                    className='select-stock-search form-control'
                  >
                    {select_menu_data[this.state.filterDealState1].map((data, i) => (
                      <option value={data.value} key={i}>
                        {data.label}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div className='alignHorizontal'>
                <button onClick={this.clearFilter} type='button' className='btn btn-sm btn-outline-success'>
                  <span className='icon icon-erase' />
                </button>
                {this.state.pendingFetch ? (
                  <img src={ringAnim} alt='' />
                ) : (
                  <button
                    onClick={() => this.refreshSearch(0)}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-cw' />
                  </button>
                )}
              </div>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>Nom</th>
                        <th>
                          <CustomerSelect
                            className='select-stock-search form-control'
                            name='filterDealCustomer'
                            onChange={(val) => this.handleInputSelectChange('filterDealCustomer', val)}
                            placeholder={'Client'}
                          />
                        </th>
                        <th>
                          <Select
                            className='select-stock-search form-control'
                            name='filterDealType'
                            value={this.state.filterDealType}
                            labelKey={'name'}
                            valueKey={'id'}
                            options={dataDealType}
                            onChange={(val) => this.handleInputSelectChange('filterDealType', val)}
                            noResultsText={'Aucun résultat'}
                            placeholder={'Type'}
                            clearValueText={'Supprimer'}
                          />
                        </th>
                        <th>
                          <Select
                            className='select-stock-search form-control'
                            name='filterDealEmployeeCreator'
                            value={this.state.filterDealEmployeeCreator}
                            labelKey={'firstname'}
                            valueKey={'id'}
                            options={dataEmployee}
                            onChange={(val) => this.handleInputSelectChange('filterDealEmployeeCreator', val)}
                            noResultsText={'Aucun résultat'}
                            placeholder={'Créé par'}
                            clearValueText={'Supprimer'}
                          />
                        </th>
                        <th>PDC</th>
                        <th className='cursor' onClick={() => this.toggleDateFiltering('filterDealDateASC')}>
                          Date création{' '}
                          <span className={'icon icon-triangle-' + (this.state.filterDealDateASC ? 'up ' : 'down ')} />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataDeal ? (
                        dataDeal.map((data, i) => (
                          <tr
                            key={data.id}
                            className={'' + (i % 2 !== 0 && 'highlighted ')}
                            style={{
                              borderLeft: data.stepNumber !== 2 ? 'inherit' : '10px solid ' + this.getRowColor(data),
                            }}
                          >
                            <td>
                              <Link onClick={this.close} to={linkToDeal + data.id}>
                                <span title={data.name}>{data.name}</span>
                              </Link>
                            </td>
                            <td>
                              <Link onClick={this.close} to={linkToCustomer + data.customer.id}>
                                <span title={data.customer.installationSite.socialReason}>
                                  {data.customer.installationSite.socialReason}
                                </span>
                              </Link>
                            </td>
                            <td>
                              <span title={data.type.name}>{data.type.name}</span>
                            </td>
                            <td>
                              <Link onClick={this.close} to={linkToUser + data.creator.user.id}>
                                <span>{data.creator.user.username}</span>
                              </Link>
                            </td>
                            <td>
                              <span>
                                {data.stepCommercial.proposition ? data.stepCommercial.proposition.pdc : '__'}
                              </span>
                            </td>
                            <td>
                              <span>{moment(data.dateLastStep).format('DD-MM-YY')}</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <li className='list-group-item'>Chargement...</li>
                      )}
                      {noDeal}
                    </tbody>
                  </table>
                  {this.state.hasMore && (
                    <div className='list-see-more'>
                      {this.state.pendingFetch ? (
                        <img src={ringAnim} alt='' />
                      ) : (
                        <button onClick={this.seeMore} type='button' className='btn btn-sm btn-outline-success'>
                          <span className=''>Voir plus</span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ExtendDeal);
